import { ErrorMessage, Field, useFormikContext } from "formik";
import { Checkbox } from "primereact/checkbox";

function CheckBoxComponent(props: any) {
  const { name, label, value, warn, isRequired, showDisabled, ...rest } = props;
  const { setFieldTouched, setFieldValue } = useFormikContext();

  return (
    <>
      {(!rest.disabled || value || showDisabled) && (
        <div className="flex flex-column w-full m-1" id={name.split(".").pop()}>
          <div className="flex align-items-center">
            <Field
              onBlur={() => {}}
              checked={value}
              alt={name}
              name={name}
              inputId={name + "Id"}
              {...rest}
              as={Checkbox}
              onChange={(e: any) => {
                setFieldTouched(name, true, true);
                setFieldValue(name, e.checked);
              }}
            />
            <label className={isRequired ? "isRequired ml-2 mt-0 w-auto" : "ml-2 mt-0 w-auto"} htmlFor={name + "Id"}>
              {" "}
              {label}
            </label>
          </div>
          {warn && <div className=" text-left fieldadv">{warn}</div>}
          <ErrorMessage name={name} render={(msg) => <div className="error">{msg}</div>} />
        </div>
      )}
    </>
  );
}
export default CheckBoxComponent;
